import { useEffect, useState } from 'react'
import { api } from '~/services/api'

export type Proposal = {
  proposalId: string;
  title: string;
  description: string;
  bountyBps: number;
  status: string;
  githubIssueUrl: string;
  approveVotesFor: number;
  approveVotesAgainst: number;
  deleteVotesFor: number;
  deleteVotesAgainst: number;
  createdAt: string;
  works: Array<{
    workId: string;
    title: string;
    status: string;
    createdAt: string;
  }>;
}

export function useGameProposals({ gameId }: { gameId: string }) {
  const [proposals, setProposals] = useState<Proposal[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    const fetchProposals = async () => {
      try {
        const gameData = await api.games.getById(gameId)
        // Transform API proposals to match our Proposal type
        const transformedProposals: Proposal[] = (gameData.proposals || []).map(p => ({
          proposalId: p.proposalId,
          title: p.title,
          description: p.title, // Using title as description since it's not provided
          bountyBps: p.bountyBps,
          status: p.status,
          githubIssueUrl: p.githubIssueUrl || '', // Use the githubIssueUrl from API response
          approveVotesFor: parseInt(p.approveVotesFor || '0', 10), // Parse string to number
          approveVotesAgainst: parseInt(p.approveVotesAgainst || '0', 10), // Parse string to number
          deleteVotesFor: 0, // Not provided by API yet
          deleteVotesAgainst: 0, // Not provided by API yet
          createdAt: p.createdAt,
          works: [], // Not provided in the initial API response
        }))
        setProposals(transformedProposals)
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch proposals'))
      } finally {
        setLoading(false)
      }
    }

    fetchProposals()
  }, [gameId])

  return {
    proposals,
    isLoading: loading,
    error,
  }
} 